
<app-nav></app-nav>
<div class="senior-citizen-quote">
  <div class="row" >
    <div class="breadcumb row"  style="display: flex; justify-content: center;">
      <ul>
        <li>Age</li>
        <li>Quotes</li>
        <li class="active">Proposal Form</li>
        <li>Payment</li>
      </ul>
    </div>
    <div class="row heading-row mt-3">
      <div style="color:#005BAA">Proposal Form for Care Health Insurance</div>
      <div><img src="https://securenow.in/static/images/Care_logo_DCA.webp"/></div>
    </div>
    <div class="row heading-row mt-3">
      <div style="color:#005BAA">Product</div>
    </div>
    <div class="row heading-row mt-3">
      <div class="product-name">Care Family Health Senior Citizen Insurance</div>
    </div>
    
    <div class="row heading-row mt-3">
      <div style="color:#005BAA">Your Details</div>
    </div>
    <div class="row  heading-row">
      <div class="col-md-2 col-lg-2 col-6  mt-3" style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span><select class="form-control sm-Invoice-Value" style="width: 95%;" value="{{title}}" [(ngModel)]="title">
          <option value="Mr.">Mr.</option>
          <option value="Ms.">Ms.</option>
          <option value="Mrs.">Mrs.</option>
        </select>
      </div>
      <div class="col-md-5 col-lg-5 col-12 mt-3"  style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span> <input type="text" class="form-control" style="width: 99%;" [(ngModel)]="firstName" placeholder="First Name" >
      </div>
      <div class="col-md-5 col-lg-5 col-12  mt-3" style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span> <input type="text" class="form-control"  [(ngModel)]="lastName" style="width: 99%;" placeholder="Last Name" >
      </div>
    </div>
    <div class="row heading-row">
      <div class="col-md-2"></div>
      <div class="col-md-3 col-lg-3 col-12  mt-3" style="display: flex; justify-content: space-between;">
        <span style="color: red;"> *</span><input type="text"  style="width:99%" class="form-control" class="form-control"  name="mobile" value="{{mobile}}"
        placeholder="Mobile No."  maxlength="10" [(ngModel)]="mobile"  pattern="\d*"  (keypress)="handlingEvents($event)">
      </div>
      <div class="col-md-3 col-lg-3 col-12  mt-3" style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span><input type="text" style="width:99%" class="form-control" name="email" id="email" placeholder="Email"
        [(ngModel)]="email"  maxlength="100" required>
      </div>
      <div class="col-md-4 col-lg-4 col-12  mt-3" style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span><input type="text" style="width:99%" class="form-control" name="dob" id="dob" placeholder="Date of Birth" value="{{dob}}"
        [(ngModel)]="dob"  maxlength="100" onfocus="(this.type='date')" onblur="(this.type='text')" max="{{currentDate}}">
      </div>
    </div>
    <div class="row heading-row">
      <div class="col-md-2"></div>
      <div class="col-md-10 col-lg-10 col-12  mt-3" style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span><input type="text" style="width:99%" class="form-control" name="address" id="address" placeholder="Address"
        [(ngModel)]="address"  maxlength="100" required>
      </div>
    </div>
    <div class="row heading-row">
      <div class="col-md-2"></div>
      <div class="col-md-3 col-lg-3 col-12  mt-3" style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span><select class="form-control sm-Invoice-Value" style="width: 99%;" value="{{gender}}" [(ngModel)]="gender">
          <option value="" selected disabled>Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>
      </div>
      <div class="col-md-3 col-lg-3 col-6  mt-3" style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span><select class="form-control sm-Invoice-Value" style="width: 99%;" value="{{state}}" [(ngModel)]="state" (change)="callCityListAPI($event)">
          <option value="" selected disabled>Select State</option>
          <option *ngFor="let data of stateList; let i=index" value="{{data.stateCode}}">{{data.stateName}}</option>
        </select>
      </div>
      <div class="col-md-4 col-lg-4 col-6  mt-3" style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span><select class="form-control sm-Invoice-Value" style="width: 99%;" value="{{city}}" [(ngModel)]="city">
          <option value="" selected disabled>Select City</option>
          <option *ngFor="let data of cityList; let i=index" value="{{data.cityName}}">{{data.cityName}}</option>
        </select>
      </div>
    </div>
    <div class="row heading-row">
      <div class="col-md-2"></div>
      <div class="col-md-3 col-lg-3 col-12  mt-3" style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span><input type="text" style="width:99%" maxlength="6" class="form-control" (keypress)="handlingEvents($event)" name="pincode" id="pincode" placeholder="Pincode"
        [(ngModel)]="pincode" required>
      </div>
      <div class="col-md-3 col-lg-3 col-6  mt-3" style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span><input type="number" disabled style="width:99%" class="form-control" name="age" id="age" placeholder="Age"
        [(ngModel)]="age" required>
      </div>
      <div class="col-md-4 col-lg-4 col-6 mt-3" style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span><select class="form-control sm-Invoice-Value" style="width: 99%;" value="{{maritialStatus}}" [(ngModel)]="maritialStatus" disabled>
          <option value="" selected disabled>Select Maritial Status</option>
          <option value="Single">Single</option>
          <option value="Married">Married</option>
        </select>
      </div>
    </div>
    <div class="row heading-row mt-3">
      <div style="color:#005BAA">Nominee Details</div>
    </div>
    <div class="row  heading-row mt-3">
      <div class="col-md-2 col-lg-2 col-6  mt-3" style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span><select class="form-control sm-Invoice-Value" style="width: 95%;" value="{{nomineeTitle}}" [(ngModel)]="nomineeTitle">
          <option value="Mr.">Mr.</option>
          <option value="Ms.">Ms.</option>
          <option value="Mrs.">Mrs.</option>
        </select>
      </div>
      <div class="col-md-5 col-lg-5 col-12  mt-3"  style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span> <input type="text" class="form-control" style="width: 99%;" [(ngModel)]="nomineeFirstName" placeholder="Nominee First Name" >
      </div>
      <div class="col-md-5 col-lg-5 col-12  mt-3" style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span> <input type="text" class="form-control"  [(ngModel)]="nomineeLastName" style="width: 99%;" placeholder="Nominee Last Name" >
      </div>
    </div>

    <div class="row  heading-row">
      <div class="col-md-2 col-lg-2 col-6" style="display: flex; justify-content: space-between;">
      </div>
      <div class="col-md-3 col-lg-3 col-12  mt-3" style="display: flex; justify-content: space-between;">
          <span style="color: red;">*</span><input type="text" style="width:99%" class="form-control" name="nomnineedob" id="nomnineedob" placeholder="Nominee Date of Birth"
          [(ngModel)]="nomnineedob"  maxlength="100" onfocus="(this.type='date')"  onblur="(this.type='text')" max="{{currentDate}}">
        </div>
      <div class="col-md-3 col-lg-3 col-6  mt-3" style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span><select class="form-control sm-Invoice-Value" style="width: 99%;" value="{{nomineeGender}}" [(ngModel)]="nomineeGender">
          <option value="" selected disabled>Select Nominee Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>
      </div>
      <div class="col-md-4 col-lg-4 col-6  mt-3" style="display: flex; justify-content: space-between;">
        <span style="color: red;">*</span><select class="form-control sm-Invoice-Value" style="width: 99%;" value="{{nomineeRelation}}" [(ngModel)]="nomineeRelation">
          <option value="" selected disabled>Select Nominee Relation</option>
          <option *ngFor="let data of Relation; let i=index" value="{{data.value}}">{{data.name}}</option>
        </select>
      </div>
    </div>
    <div>    
    </div>

    <div class="row heading-row mt-4">
      <div style="color:#005BAA">Spouse Details</div>
    </div>
    <div class="row  heading-row">
      <div class="col-md-2 col-lg-2 col-6  mt-3" style="display: flex; justify-content: space-between;">
        <span>&nbsp;</span> <select class="form-control sm-Invoice-Value" style="width: 95%;" value="{{spouseTitle}}" [(ngModel)]="spouseTitle" [disabled]="maritialStatus==='Single'">
          <option value="Mr.">Mr.</option>
          <option value="Mrs.">Mrs.</option>
        </select>
      </div>
      <div class="col-md-5 col-lg-5 col-12  mt-3"  style="display: flex; justify-content: space-between;">
        <span>&nbsp;</span><input type="text" class="form-control" style="width: 99%;" [disabled]="maritialStatus==='Single'" [(ngModel)]="spouseFirstName" placeholder="Spouse First Name" >
      </div>
      <div class="col-md-5 col-lg-5 col-12  mt-3" style="display: flex; justify-content: space-between;">
        <span>&nbsp;</span><input type="text" class="form-control" [disabled]="maritialStatus==='Single'" [(ngModel)]="spouseLastName" style="width: 99%;" placeholder="Spouse Last Name" >
      </div>
    </div>

    <div class="row  heading-row ">
      <div class="col-md-2 col-lg-2 col-6" style="display: flex; justify-content: space-between;">
      </div>
      <div class="col-md-3 col-lg-3 col-12  mt-3" style="display: flex; justify-content: space-between;">
        <span>&nbsp;</span><input type="text" style="width:99%" class="form-control"[disabled]="maritialStatus==='Single'"  name="spouseDob" id="spouseDob" placeholder="Spouse Date of Birth"
          [(ngModel)]="spouseDob"  maxlength="100" onfocus="(this.type='date')"  onblur="(this.type='text')" max="{{currentDate}}">
        </div>
      <div class="col-md-3 col-lg-3 col-6  mt-3" style="display: flex; justify-content: space-between;">
        <span>&nbsp;</span><select class="form-control sm-Invoice-Value"[disabled]="maritialStatus==='Single'"  style="width: 99%;" value="{{spouseGender}}" [(ngModel)]="spouseGender">
          <option value="" selected disabled>Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>
      </div>
      <div class="col-md-4 col-lg-4 col-6  mt-3" style="display: flex; justify-content: space-between;">
        <span>&nbsp;</span><select class="form-control sm-Invoice-Value" [disabled]="maritialStatus==='Single'"  style="width: 99%;" value="{{spouseRelationship}}" [(ngModel)]="spouseRelationship">
          <option value="" selected disabled>Select Relationship</option>
          <option value="Husband">Husband</option>
          <option value="Wife">Wife</option>
        </select>
      </div>
    </div>

    <div class="row heading-row mt-3">
      <div class="col-md-2"></div>
      <div class="col-md-10 col-lg-10 col-12  mt-3" style="display: flex; justify-content: space-between;">
        <span>&nbsp;</span><select class="form-control sm-Invoice-Value" style="width: 99%;" disabled value="{{sumAssured}}" [(ngModel)]="sumAssured">
          <option value="" selected disabled>Select Sum Assured</option>
          <option value="300000">300000</option>
          <option value="500000">500000</option>
        </select>
      </div>
    </div>

    <div class="row heading-row mt-4" style="display: flex;">
      <div class="col-md-12 col-lg-12">
      <input type="checkbox"  type="checkbox" name="goodHealthDec" value="{{goodHealthDec}}" [(ngModel)]="goodHealthDec">
      <span>
        I hereby declare that all proposed members are in good health and entirely free from any mental or physical impairments or deformities, disease/condition. Neither any of the proposed members have been hospitalized for treatment of an illness or injury in past nor consulted any physician or conducted investigation for reasons other than common cough, cold or flu. None of the proposed member are habitual consumer of alcohol, tobacco, gutka or any recreational drugs
      </span>
    </div>
    </div>

    <div class="row heading-row mt-4" style="display: flex;">
      <div class="col-md-12 col-lg-12">
      <input type="checkbox" name="webTermsAndCond" value="{{webTermsAndCond}}" [(ngModel)]="webTermsAndCond">
      <span>
        I hereby agree to the <a target="_blank" href="https://securenow.in/terms-conditions">terms & conditions</a> of the purchase of this policy.
      </span>
    </div>
    </div>

    <div class="row heading-row mt-4" style="display: flex;">
      <div class="col-md-12 col-lg-12">
      <input type="checkbox" name="appTermsAndCond" value="{{appTermsAndCond}}" [(ngModel)]="appTermsAndCond" >
      <span>
        I hereby agree to the <a target="_blank" href="https://static-files-website.s3.ap-south-1.amazonaws.com/terms+and+conditions/SecureNow+App+terms.pdf">terms & conditions</a> of the Securenow app.
      </span>
    </div>
    </div>

    <div class="row heading-row mt-4" style="display: flex;" *ngIf="errorMessage!=''">
      <div class="col-md-12 col-lg-12">
    <span style="font-size: 14px; color:red">{{errorMessage}}</span>
    </div>
    </div>

    <div class="row heading-row mt-4" style="display: flex;">
      <div class="col-md-12 col-lg-12">
      <button class="btn buy-btn" (click)="buyInsurance()">Buy</button>
    </div>
    </div>

    </div>
    </div>
   

    <div class="modal fade" id="thankyou" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header" style="text-align: center;">
            Good Health Declaration Terms And Conditions
          </div>
          <div class="ml-2 mr-2 mt-2" style="font-size: 13px;">
            <ul>
              <p>a) You have not declared that you are in good health. Please await a call from the insurer at your contact number provided.</p>
              <p>b) The insurer will understand your health condition and confirm the way forward. The insurer's call and next steps can take up to fifteen working days.</p>
              <p>c) Please note these steps will only happen if you successfully pay the premium that was indicated to you. In case the insurer rejects your policy, the premium amount you've paid will be fully refunded to your payment mode.</p>
              <p>d) You may choose to click Proceed and pay your premium if you agree with the above, or else go back or exit"</p>
            </ul>
          </div>
          <div class="ml-4 mr-4 mb-4" style="display: flex; justify-content: space-evenly;">
            <button type="button" class="btn btn-green" data-dismiss="modal" (click)="closeDeclarationModal()" >Cancel</button>
            <button type="button" class="btn btn-red" data-dismiss="modal" (click)="saveSeniorData()">Submit</button>
          </div>
        </div>
      </div>
    </div>
